
document.addEventListener('DOMContentLoaded', function () {
    function show_hide_color () {
        $('.product-color-swatch-wrapper .swatch').removeClass('hidden');
        $('.variant_list .variant_item .item:not(.active)').each(function () {
            const htmlContent = $(this).attr('data');
            $(this).parents('.variant_list').find(`.swatch[data*='${htmlContent}']`).addClass('hidden');
        });
    }
    show_hide_color();
    $('.product-color-swatch-wrapper .swatch').click(function () {
        $(this).addClass('active').siblings().removeClass('active');
        let variant_id = $(this).data('id');
        let variant_sku = $(this).data('sku');
        let available = $(this).data('varavailable');
        $(this)
            .parents('.top_wrapper')
            .find('.price_list')
            .find(`.price[data-id=${variant_id}]`)
            .addClass('active')
            .siblings()
            .removeClass('active');
        $(this)
            .parents('.product_item')
            .find(`.variant-image[data-id='${variant_id}']`)
            .addClass('active')
            .siblings()
            .removeClass('active')
        $(this).parents('.top_wrapper').find('.addtocart').attr('data-variant-id', variant_id);
        if (available) {
            $(this).parents('.top_wrapper').find('.addtocart').removeClass('disabled');
            $(this).parents('.top_wrapper').find('.addtocart.add_cart').text('Add to Cart');
            $(this).parents('.top_wrapper').find('.addtocart.buy_now').text('Buy Now');
        } else {
            $(this).parents('.top_wrapper').find('.addtocart').addClass('disabled');
            $(this).parents('.top_wrapper').find('.addtocart').text('Sold Out');
        }
        $(this).parents('.buy-card').find('.product-item.product_info').attr('data-sku', variant_sku);
    });

    $('.variant_list .variant_item .item').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active').siblings().removeClass('active');
            if ($(this).attr('data') == 'custom-item') {
                // $(this).parents('.top_wrapper').find('.square').hide();
                $(this).parents('.product_item').find('.corner-marker').hide();
                $(this).parents('.product_item').find('a').attr('href', $(this).data('url'));
                $(this).parents('.top_wrapper').find('.product_color_item').eq(0).removeClass('active').addClass('hidden');
                $(this).parents('.top_wrapper').find('.product_color_item').eq(1).addClass('active').removeClass('hidden');
                $(this).parents('.top_wrapper').find('.product-title').eq(0).addClass('hidden');
                $(this).parents('.top_wrapper').find('.product-title').eq(1).removeClass('hidden');
                $(this).parents('.product_item').find('.discount').eq(0).addClass('hidden');
                $(this).parents('.product_item').find('.discount').eq(1).removeClass('hidden');
                $(this).parents('.product-box').find('.variant-img-content').eq(0).addClass('hidden');
                $(this).parents('.product-box').find('.variant-img-content').eq(1).removeClass('hidden');
                $(this).parents('.product-box').find('.price_list').eq(0).addClass('hidden').removeClass('active');
                $(this).parents('.product-box').find('.price_list').eq(1).removeClass('hidden').addClass('active');
                setTimeout(() => {
                    $(this)
                        .parents('.top_wrapper')
                        .find(`.product_color_item.active .product-color-swatch-wrapper .swatch`)
                        .eq(0)
                        .click();
                    if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                        $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C')
                    }
                }, 20);
            } else {
                if ($(this).parents('.product_item').find('.product_color_item').length > 1) {
                    $(this).parents('.product_item').find('.corner-marker').show();
                    $(this).parents('.product_item').find('a').attr('href', $(this).parents('.product_info').data('url'));
                    $(this).parents('.top_wrapper').find('.square').show();
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(1).removeClass('active').addClass('hidden');
                    $(this).parents('.top_wrapper').find('.product_color_item').eq(0).addClass('active').removeClass('hidden');
                    $(this).parents('.top_wrapper').find('.product-title').eq(1).addClass('hidden');
                    $(this).parents('.top_wrapper').find('.product-title').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.discount').eq(0).removeClass('hidden');
                    $(this).parents('.product_item').find('.discount').eq(1).addClass('hidden');
                    $(this).parents('.product-box').find('.variant-img-content').eq(0).removeClass('hidden');
                    $(this).parents('.product-box').find('.variant-img-content').eq(1).addClass('hidden');
                    $(this).parents('.product-box').find('.price_list').eq(0).removeClass('hidden').addClass('active');
                    $(this).parents('.product-box').find('.price_list').eq(1).addClass('hidden').removeClass('active');
                }
                if ($(this).parents('.product_item').hasClass('openfit2plus')) {
                    $(this).parents('.product_item').find('.variant_item').find('.item.active').text('USB-C + Wireless Charging')
                }

                if ($(this).attr('data') == 'No Adapter') {
                    $(this).parents('.top_wrapper').find('.square').hide();
                } else {
                    $(this).parents('.top_wrapper').find('.square').show();
                }

                if ($(this).parents('.product_item').hasClass('openmeet')) {
                    if ($(this).attr('data') == 'No Adapter') {
                        $(this).parents('.product_item').find('.discount').find('span').text('30% OFF')
                    } else {
                        $(this).parents('.product_item').find('.discount').find('span').text('25% OFF')
                    }
                }

                setTimeout(() => {
                    show_hide_color();
                    $(this)
                        .parents('.top_wrapper')
                        .find(`.product_color_item.active .product-color-swatch-wrapper .swatch:not(.hidden)`)
                        .eq(0)
                        .click();
                }, 20);
            }
        }
    });

    $(".product-color-swatch-wrapper .swatch[data-id='44043747819720']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44602038485192']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='44758320742600']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='43714848686280']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='45040472654024']").click()
    $(".product-color-swatch-wrapper .swatch[data-id='43676376858824']").click()

    $('.bottom_item .bottom_cart .add_btn,.slide_card .slide_bottom .add_btn').click(function () {
        $(this).parents('.bottom_item').find('add-cart-button').eq(0).click();
    });
});

